import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10h14l-4 -4","key":"svg-0"}],["path",{"d":"M17 14h-14l4 4","key":"svg-1"}]]

const IconArrowsExchange = createReactComponent('outline', 'arrows-exchange', 'ArrowsExchange', __iconNode);

export default IconArrowsExchange;